// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c45f0ac","484":"e8b11fd9","551":"1f11c12a","578":"f54f8942","622":"57fbee60","977":"4b1ccf53"}[chunkId] + ".chunk.js";
};